import React from 'react';
import styled from 'styled-components';
import {fontSize, tabletWidth} from '../mixins';


const StyledNavigation = styled.nav`

    ${props => props.responsive && `
       @media screen and (min-width: 767px) {
         width: 55vw;
         margin-left: auto;
       }`
} 

   ul {
    min-width: 50vw;
    margin: 0;
    padding: 0;
    list-style: none;
    ${fontSize(16)};
    line-height: 20px;
    font-weight: 400;
    color: #000000;
    
    ${props => props.responsive && `
         @media screen and (min-width: 767px) {
          min-width: unset;
          display: flex;
          justify-content: space-between;
          align-items: center;
           ${fontSize(18)};
          line-height: 24px;
        }`
} 
  }

  li {
    padding: 12px 24px;
    
    @media screen and (max-width: ${tabletWidth}) {
      &:hover {
        background-color: #E9E9E9;
      }
    }
  }

  a, button  {
    color: #000000;
    background-color: transparent;
    border: none;

    &:hover,
    &:active {
      text-decoration: underline;
      color: #000000;
    }
  }
`


const renderNavList = (name, href, onClick) => {

    if (onClick) {
        return (
            <li key={name}>
                <button onClick={onClick}>{name}</button>
            </li>
        );
    }

    return (
        <li key={name}>
            <a href={href}>{name}</a>
        </li>
    );
};


const Navigation = ({links, responsive}) => {

    return (
        <StyledNavigation responsive={responsive}>
            <ul>
                {links.map(i => renderNavList(i.name, i.link, i.onClick))}
            </ul>
        </StyledNavigation>

    );
};


export default Navigation;


